/**
 * Lowest variant price that was actually entered.
 * Empty, null, and non-numeric values are ignored: in JS `null < 10` is true,
 * so a blank line must not become the hidden reference price.
 * Returns null when no line has a usable price.
 */
export function lowestEnteredVariantPrice(variants: Record<string, { price?: unknown }> | null | undefined): number | null {
    if (!variants) {
        return null;
    }

    let lowest: number | null = null;
    for (const variant of Object.values(variants)) {
        const price = enteredVariantPrice(variant?.price);
        if (price == null) {
            continue;
        }
        if (lowest == null || price < lowest) {
            lowest = price;
        }
    }
    return lowest;
}

function enteredVariantPrice(value: unknown): number | null {
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
    }
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed === '') {
            return null;
        }
        const price = Number(trimmed);
        return Number.isFinite(price) ? price : null;
    }
    return null;
}
